import React from 'react';
import PropTypes from 'prop-types';
import CustomSelect from '../FormInputs/CustomSelect/CustomSelect';
import { switchOrganization } from '../../utils/api/organization';

const UserRoleInfo = ({
  currentUser, organizationId, selectedOrg, showToast,
}) => {
  if (!currentUser) return null;

  const { user_organizations: userOrganizations = [], organizations = [] } = currentUser;

  const truncateLabel = (text) => {
    if (!text) return '';
    return text.length > 17 ? `${text.slice(0, 17)}...` : text;
  };

  const getRoleForOrg = (orgId) => {
    const userOrg = userOrganizations.find((uo) => uo.organization_id === orgId);
    return userOrg ? userOrg.role : '';
  };

  const options = organizations.map((org) => ({
    value: org.id,
    label: `${truncateLabel(org.name)} - ${org.code} (${getRoleForOrg(org.id)})`,
  }));

  const matchedOrg = userOrganizations.find(
    (organization) => organization.organization_id === organizationId,
  );
  const selectedOption = options.find((option) => option.value === organizationId);

  if (userOrganizations.length === 1 && organizations.length === 1) {
    return (
      <span className="font-semibold text-lg text-vamos-white">
        {userOrganizations[0].role} for {organizations[0].name}
      </span>
    );
  }

  if (!matchedOrg || !selectedOption) return null;

  return (
    <div className="flex items-center space-x-2 text-lg font-semibold">
      <span className="text-vamos-white whitespace-nowrap">{matchedOrg.role} for</span>
      <CustomSelect
        value={truncateLabel(selectedOrg?.label)}
        options={options}
        setValue={async (selected) => {
          try {
            const response = await switchOrganization(selected.value);
            if (response.ok) {
              if (window.location.pathname.includes('/admin/organizations')) {
                window.location.href = `/admin/organizations/${selected.value}`;
              } else {
                window.location.reload();
              }
            }
          } catch (err) {
            showToast({ message: err.message, type: 'error' });
          }
        }}
        placeholder={selectedOrg?.label}
        inputHeight="h-10"
        inputWidth="w-77.5"
        dataTestId="organization-switcher"
      />
    </div>
  );
};

UserRoleInfo.propTypes = {
  currentUser: PropTypes.object.isRequired,
  organizationId: PropTypes.number.isRequired,
  selectedOrg: PropTypes.object.isRequired,
  showToast: PropTypes.func.isRequired,
};

export default UserRoleInfo;
